import {Text} from 'react-native';
import React from 'react';
import {Typography} from 'src/styles';
import {compose} from 'recompose';
import {withDatabase} from '@nozbe/watermelondb/react';
import {withObservables} from '@nozbe/watermelondb/react';
import {Prompt} from 'src/models';

const PromptView = ({
  prompt,
  fieldName = 'acronym',
  textStyle = 'CAPTION',
}: any) => {
  return (
    <>
      <Text style={[Typography[textStyle]]}>{prompt?.[fieldName]}</Text>
    </>
  );
};

export default compose(
  withDatabase,
  withObservables(['promptId'], ({database, promptId}: any) => {
    return {
      prompt: database.get(Prompt.table).findAndObserve(promptId),
    };
  }),
)(PromptView);
